import { styled } from '@compiled/react';
import styled2 from 'styled-components';
import { isJSMRedirectBannerEnabled } from '@helpCenter/feature-flags';
import { token } from '@atlaskit/tokens';
import { Flipper } from '../../utils/flip-toolkit';

// eslint-disable-next-line rulesdir/no-styled-export
export const ConversationWrapper = styled.div({
    width: '100%',
    flex: '1 1 auto',
});

const BANNER_HEIGHT = isJSMRedirectBannerEnabled() ? `var(--bannerHeight)` : `0px`;

/* Suppressing existing violations */
/* stylelint-disable scale-unlimited/declaration-strict-value, function-parentheses-newline-inside   */
// eslint-disable-next-line rulesdir/no-styled-export
export const ConversationFlipper = styled2(Flipper)`
    width: 100%;
    height: 100%;
    max-height: calc(100vh - var(--topNavigationHeight) - ${BANNER_HEIGHT} - ${token('space.1000', '80px')} - ${token(
    'space.600',
    '48px'
)} - ${token('space.300', '24px')});
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;
/* stylelint-enable scale-unlimited/declaration-strict-value, function-parentheses-newline-inside   */
